import * as React from 'react';
require('./style.css');

interface IProps {
	name?: string;
	text: any;
	tag?: 'label' | 'div';
}
/**
 *
 * @param props
 */
export const PortalFieldLabel = (props: IProps) => {
	const Tag = props.tag || 'label';
	return (
		<Tag htmlFor={Tag === 'label' ? props.name : undefined} className="inputLabel">
			{props.text}
		</Tag>
	);
};
